'use client'
export default function CourseDetail() {

}